<header>
    <div class="container">
        <div class="flex top-bar acenter">
            <div class="logo" *ngIf="!router.url.startsWith('/receita/')">
                <ng-container *ngIf="isDarkMode; else lightLogo">
                    <a routerLink="/">
                        <img src="logo_white.png" alt="Logo">
                    </a>
                </ng-container>

                <ng-template #lightLogo>
                    <a routerLink="/">
                        <img src="logo_small.png" alt="Logo">
                    </a>
                </ng-template>
            </div>
            <button class="menu-toggle-btn" *ngIf="!router.url.startsWith('/receita/')"
                    (click)="onMenuToggle()" [title]="'Menu' | translate">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round">
                    <line x1="3" y1="6" x2="21" y2="6"/>
                    <line x1="3" y1="12" x2="21" y2="12"/>
                    <line x1="3" y1="18" x2="21" y2="18"/>
                </svg>
            </button>
            <div class="logo-bar" [ngClass]="router.url.startsWith('/receita/') ? 'none' : 'show'"></div>
            <div class="language-buttons">
                <button (click)="LanguageService.changeLanguage('es')"><img src="./images/flag-spain.svg"></button>
                <button (click)="LanguageService.changeLanguage('pt')"><img src="./images/flag-brazil.svg"></button>
                <button (click)="LanguageService.changeLanguage('en')"><img src="./images/flag-us.svg"></button>
            </div>
            <div class="tips">
                <button (click)="showTips = !showTips" class="tooltip-button" title="{{ 'Atalhos de teclado para página de detalhes' | translate}}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                </button>

                <button (click)="toggleDarkMode()">
                    <ng-container *ngIf="isDarkMode; else lightIcon">
                    <!-- Ícone Sol -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="5"/>
                        <path d="M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"/>
                    </svg>
                    </ng-container>

                    <ng-template #lightIcon>
                    <!-- Ícone Lua -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
                    </svg>
                    </ng-template>
                </button>
            </div>
        </div>
    </div>
</header>

<div class="tooltip" [ngClass]="showTips ? 'show' : 'hide'">
    <div class="tooltip-close" (click)="showTips = false">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#A9A9A9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
    </div>
    <div class="tooltip-content">
        <app-tooltip-text></app-tooltip-text>

        <button (click)="abrirTooltip()" class="button">
        {{ 'Abrir pop-up' | translate }}
        </button>
    </div>
</div>
